/**
 * Temporary feedback service until API client is regenerated
 * TODO: Remove this file after running `npm run generate-client`
 */

import type { CancelablePromise } from "@/client/core/CancelablePromise"
import { OpenAPI } from "@/client/core/OpenAPI"
import { request as __request } from "@/client/core/request"

export interface QuestionFeedbackPublic {
  id: string
  feedback_text: string
  quiz_id: string
  question_id: string
  status: "unread" | "read" | "resolved"
  is_published: boolean
  parent_id: string | null
  created_at: string
  updated_at: string
  is_own: boolean
  created_by_name?: string
  assigned_to_name?: string
  replies: QuestionFeedbackPublic[]
}

export type FeedbackByQuiz = Record<string, QuestionFeedbackPublic[]>

export const FeedbackServiceTemp = {
  /**
   * Get all feedback submitted by current user, grouped by quiz
   */
  getMyFeedback(): CancelablePromise<FeedbackByQuiz> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/my-feedback",
    })
  },

  /**
   * Get organization feedback with optional filters
   */
  getOrganizationFeedback(
    data: {
      questionId?: string
      status?: string
      assignedTo?: string
      quizId?: string
      skip?: number
      limit?: number
    } = {},
  ): CancelablePromise<QuestionFeedbackPublic[]> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/organization-feedback",
      query: {
        question_id: data.questionId,
        status: data.status,
        assigned_to: data.assignedTo,
        quiz_id: data.quizId,
        skip: data.skip,
        limit: data.limit,
      },
    })
  },
}
